import classNames from 'classnames'
import { Modal } from 'components/layout/Modal'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { Me } from 'service/user'
import { FormValues } from 'utils/type'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { ReactComponent as TrashIcon } from 'svg/trash.svg'
import { useInfiniteLinks } from 'hooks/query/extension/useGetLinks'
import {
  AIRecommendProductShortTitleType,
  AiThumbnailTitle,
  Link,
  LinkDetailType,
  LinkInfo,
} from 'service/list'
import useDeleteLink from 'hooks/query/extension/useDeleteLink'
import { useGetLinkDetails } from 'hooks/query/extension/useGetLinkDetail'
import InfiniteScroll from 'react-infinite-scroll-component'

import { BeatLoader } from 'react-spinners'

import { getLocalStorage } from 'utils/common'

import { UseMutateAsyncFunction } from '@tanstack/react-query'
import { MaxSelectCnt } from 'constant/videoTypes'

interface ExtensionListModalProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  translatePlanName?: (planName: string) => string
  userInfo: Me
  setOpenExtensionMethod: Dispatch<SetStateAction<boolean>>
  isOpenExtensionMethod: boolean
  selectedLinkIds: number[]
  setSelectedLinkIds: Dispatch<SetStateAction<number[]>>
  linkPageSize: number
  setLinkPageSize: Dispatch<SetStateAction<number>>
  linkCurrentPage: number
  setLinkCurrentPage: Dispatch<SetStateAction<number>>
  LINK_PAGE_CNT: number
  setSelectedLinks: Dispatch<SetStateAction<LinkDetailType[]>>
  isAiName: boolean
  setAiName: Dispatch<React.SetStateAction<boolean>>
  setIsOpenExtensionListFailModal: Dispatch<React.SetStateAction<boolean>>
  setAiRecommendClipTitle: Dispatch<React.SetStateAction<string[] | null>>

  setAiRecommendThumbnailTitle: Dispatch<
    SetStateAction<AiThumbnailTitle | null>
  >
  mutateAsync: UseMutateAsyncFunction<string[], Error, any, unknown>
  isPending: boolean
  thumbnailMutateAsync: UseMutateAsyncFunction<
    AiThumbnailTitle,
    Error,
    any,
    unknown
  >
  thumbnailIsPending: boolean
  createVideoType: 'long' | 'short'
}

export const ExtensionListModal = ({
  watch,
  setValue,
  control,
  translatePlanName,
  userInfo,
  setOpenExtensionMethod,
  isOpenExtensionMethod,
  selectedLinkIds,
  setSelectedLinkIds,
  linkPageSize,
  setLinkPageSize,
  linkCurrentPage,
  setLinkCurrentPage,
  LINK_PAGE_CNT,
  setSelectedLinks,
  isAiName,
  setAiName,
  setAiRecommendClipTitle,
  setAiRecommendThumbnailTitle,
  mutateAsync,
  isPending,
  thumbnailMutateAsync,
  thumbnailIsPending,
  setIsOpenExtensionListFailModal,
  createVideoType,
}: PropsWithChildren<ExtensionListModalProps>) => {
  const [isOpenErrorModal, setOpenErrorModal] = useState<boolean>(false)
  const [isOpenDeleteModal, setOpenDeleteModal] = useState<boolean>(false)
  const [deleteId, setDeleteId] = useState<number | null>(null)

  const [linkListValue, setLinkListValue] = useState<LinkInfo | undefined>(
    undefined,
  )

  const isExtensionInstalled = getLocalStorage('fs_extension')
  const [isExtension, setExtension] = useState(false)

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
    isPending: linkListPending,
    refetch: linkRefetch,
  } = useInfiniteLinks(LINK_PAGE_CNT)

  const { mutate: deleteLinkMutate, isPending: deletePending } = useDeleteLink()
  const { mutateAsync: getLinkDetail } = useGetLinkDetails(selectedLinkIds)

  const handelGetLinkDetailByIds = async () => {
    try {
      const getApis = selectedLinkIds.map((id) => getLinkDetail(id))

      const results = await Promise.all(getApis)
      if (!results) setIsOpenExtensionListFailModal(true)

      const newDataArr = results.filter(
        (el): el is LinkDetailType => el !== null,
      )

      setSelectedLinks((prev) => {
        // 기존 상태와 비교하여 변경된 경우에만 업데이트
        if (JSON.stringify(prev) !== JSON.stringify(newDataArr)) {
          return newDataArr
        }
        return prev // 값이 동일하면 상태 변경 X → 렌더링 방지
      })
    } catch (err) {
      setIsOpenExtensionListFailModal(true)
      console.error('에러 발생:', err)
    }
  }

  const handleModalOpen = () => {
    setOpenExtensionMethod((prev) => !prev)
  }
  const handleDeleteModal = () => {
    setOpenDeleteModal((prev) => !prev)
  }
  const handleErrorModal = () => {
    setOpenErrorModal((prev) => !prev)
  }
  const handleListStatus = (id: number) => {
    // 배열에 id가 존재하면 filter로 삭제
    const maxCnt =
      createVideoType === 'short'
        ? MaxSelectCnt.PRODUCT_SHORT
        : MaxSelectCnt.PRODUCT_LONG
    const check = selectedLinkIds.includes(id)
    if (check) {
      const newArr = selectedLinkIds.filter((num) => num !== id)
      setSelectedLinkIds(newArr)
    } else {
      const currentArr = [...selectedLinkIds, id]
      if (currentArr.length <= maxCnt) {
        setSelectedLinkIds(currentArr)
      }
    }
  }

  const handleDeleteLink = () => {
    if (deleteId) {
      deleteLinkMutate(deleteId, {
        onSuccess: () => {
          //linkRefetch()
          // refetch가아니라
          if (linkListValue) {
            const newLinkListValue = linkListValue?.data.links.filter(
              (el) => el.id !== deleteId,
            )
            const newSelectedLinkIds = selectedLinkIds.filter(
              (el) => el !== deleteId,
            )

            const newLinkListValueTotalCount =
              linkListValue?.data.totalCount - 1
            const newLinkListValueRemainingCapacity =
              linkListValue.data.remainingCapacity + 1

            setLinkListValue({
              data: {
                links: newLinkListValue,
                totalCount: newLinkListValueTotalCount,
                remainingCapacity: newLinkListValueRemainingCapacity,
              },
            })
            setSelectedLinkIds(newSelectedLinkIds)
            handleDeleteModal()
          }
        },
        onError: (e) => {
          console.log(e?.message)
        },
      })
    } else {
      handleDeleteModal()
    }
  }

  const handleAiRecommendClipTitle = async () => {
    const selectedIdsCnt = selectedLinkIds.length
    if (selectedIdsCnt === 0) {
      setOpenErrorModal((prev) => !prev)
    } else {
      handleModalOpen()

      const [dataResult, thumbnailResult] = await Promise.allSettled([
        mutateAsync(selectedLinkIds),
        thumbnailMutateAsync(selectedLinkIds),
      ])

      if (dataResult.status === 'fulfilled') {
        setAiRecommendClipTitle(dataResult.value ?? null)
      } else {
        setAiRecommendClipTitle(null)
      }

      if (thumbnailResult.status === 'fulfilled') {
        setAiRecommendThumbnailTitle(thumbnailResult.value ?? null)
      } else {
        setAiRecommendThumbnailTitle(null)
      }
    }
  }

  const findIcon = (shop: string) => {
    let iconPath = ''
    switch (shop) {
      case 'ali':
        iconPath = '/assets/img/ali_icon.png'
        break
      case 'coupang':
        iconPath = '/assets/img/coupang_icon.png'
        break
      case 'naver':
        iconPath = '/assets/img/naver_icon.png'
        break
      case 'smartstore':
        iconPath = '/assets/img/naver_icon.png'
        break
    }

    return iconPath
  }

  useEffect(() => {
    if (data) {
      const links = data?.pages.flatMap((page) => page.data.links) || []
      const totalCount = data?.pages.at(-1)?.data.totalCount ?? 0
      const remainingCapacity = data?.pages.at(-1)?.data.remainingCapacity ?? 0
      setLinkListValue({ data: { links, totalCount, remainingCapacity } })
      const checkList = links.filter((el) =>
        selectedLinkIds.slice(0, 3).includes(el.id),
      )
      setSelectedLinkIds(checkList.map((el) => el.id))
    }
  }, [data])

  useEffect(() => {
    setExtension(isExtensionInstalled)
  }, [isExtensionInstalled])
  useEffect(() => {
    if (isOpenExtensionMethod) {
      linkRefetch()
    }
  }, [isOpenExtensionMethod])

  const LinkRowEl = (link: Link, index: number) => {
    return (
      <div className="mb-2 flex items-center gap-2" key={`link_${index}`}>
        <div
          className={classNames(
            'flex w-full cursor-pointer items-center gap-2 rounded-[10px] px-2 py-1 md:py-3',
            {
              'opacity-30':
                selectedLinkIds.length === 3 &&
                !selectedLinkIds.includes(link.id),
              'bg-[#BBEBEC]': selectedLinkIds.includes(link.id),
              'bg-[#F6F8FB]': !selectedLinkIds.includes(link.id),
            },
          )}
          onClick={() => {
            handleListStatus(link?.id)
          }}
        >
          <input
            type="checkbox"
            className="relative h-[18px] w-[18px] flex-shrink-0 cursor-pointer appearance-none rounded-md border border-gray-400 after:absolute after:left-[5px] after:top-[2px] after:h-[10px] after:w-[5px] after:rotate-45 after:border-b-2 after:border-r-2 after:border-white after:opacity-0 after:content-[''] checked:border-main checked:bg-main checked:after:opacity-100"
            checked={selectedLinkIds.includes(link.id)}
          />

          <div className="flex flex-shrink-0 flex-col text-[12px] font-bold text-[#B6BBC6]">
            {String(index + 1).padStart(3, '0')}
            <div className="flex justify-end">
              <img
                src={findIcon(link.shop)}
                alt="youtube icon"
                className="h-[12px] w-[12px]"
              />
            </div>
          </div>
          <div className="flex-shrink-0">
            {' '}
            <img
              src={link?.thumbnailImage ?? ''}
              alt="youtube icon"
              className="h-[32px] w-[32px]"
            />
          </div>
          <div className="text-left">{link?.title}</div>
        </div>
        <div className="mr-4">
          <button
            onClick={() => {
              setDeleteId(link?.id)
              setOpenDeleteModal((prev) => !prev)
            }}
          >
            <TrashIcon />
          </button>
        </div>
      </div>
    )
  }

  const handleDisplayByMobile = () => {
    if (isMobile) {
      return (
        <>
          {linkListPending || isPending ? (
            <div className="flex items-center justify-center overflow-auto md:h-[350px] md:pb-4">
              {' '}
              <BeatLoader color="#00B7B9"></BeatLoader>
            </div>
          ) : userInfo &&
            linkListValue?.data?.totalCount &&
            linkListValue?.data?.totalCount > 0 ? (
            <>
              {' '}
              {
                <div
                  className="max-h-[90vh] overflow-auto md:h-[350px] md:pb-4"
                  id="scroll_modal"
                >
                  <InfiniteScroll
                    dataLength={linkListValue.data.links.length} // 현재 로드된 데이터의 길이
                    next={fetchNextPage} // 데이터가 더 필요할 때 호출될 함수
                    hasMore={!!hasNextPage} // 더 불러올 데이터가 있는지 여부
                    loader={<BeatLoader color="#00B7B9"></BeatLoader>} // 로딩 중에 표시될 컴포넌트
                    endMessage={<></>} // 모든 아이템을 불러왔을 때 표시될 메시지
                    scrollableTarget="scroll_modal" // 스크롤 대상 (모달의 ID 또는 클래스를 사용)
                  >
                    {linkListValue?.data.links?.map((link, index) => (
                      <>{LinkRowEl(link, index)}</>
                    ))}
                  </InfiniteScroll>
                </div>
              }
            </>
          ) : (
            isExtension && (
              <>
                <div className="overflow-auto md:h-[350px] md:pb-4">
                  <div>
                    {linkListValue?.data.totalCount === 0 && userInfo && (
                      <>
                        <p className="text-error">
                          아직 확장 프로그램에서 수집한 상품이 없어요!
                        </p>

                        <button className="mt-6 font-bold text-main">
                          <a
                            href="https://www.coupang.com"
                            target="_blank"
                            rel="noreferrer"
                          >
                            상품 수집하기 {`>`}
                          </a>
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </>
            )
          )}
        </>
      )
    } else {
      return (
        <>
          {/* {!isExtension && (
            <div className="md:overflow-auto md:h-[500px]  md:pb-4 ">
              <p className="text-error">
                아직 확장 프로그램을 설치하지 않았어요!
              </p>

              <button className=" mt-6 font-bold">
                <a
                  href="https://chromewebstore.google.com/detail/meeeiblldcmbdhhaibnbpdiiknkoaakl?utm_source=item-share-cb"
                  target="_blank"
                  rel="noreferrer"
                  className="flex gap-2 items-center"
                >
                  <img
                    src="assets/img/logo/extension.png"
                    alt="extension"
                    className="w-[26px] h-[26px]"
                  />
                  <span className="font-bold">
                    패스트컷 AI 확장 프로그램 설치하기 {`>`}
                  </span>{' '}
                </a>
              </button>
            </div>
          )} */}

          {linkListPending || isPending ? (
            <div className="flex items-center justify-center overflow-auto md:h-[350px] md:pb-4">
              {' '}
              <BeatLoader color="#00B7B9"></BeatLoader>
            </div>
          ) : userInfo &&
            linkListValue?.data?.totalCount &&
            linkListValue?.data?.totalCount > 0 ? (
            <>
              {' '}
              {
                <div
                  className="overflow-auto md:h-[350px] md:max-h-[90vh] md:pb-4"
                  id="scroll_modal"
                >
                  <InfiniteScroll
                    dataLength={linkListValue.data.links.length} // 현재 로드된 데이터의 길이
                    next={fetchNextPage} // 데이터가 더 필요할 때 호출될 함수
                    hasMore={!!hasNextPage} // 더 불러올 데이터가 있는지 여부
                    loader={<BeatLoader color="#00B7B9"></BeatLoader>} // 로딩 중에 표시될 컴포넌트
                    endMessage={<></>} // 모든 아이템을 불러왔을 때 표시될 메시지
                    scrollableTarget="scroll_modal" // 스크롤 대상 (모달의 ID 또는 클래스를 사용)
                  >
                    {linkListValue?.data.links?.map((link, index) => (
                      <>{LinkRowEl(link, index)}</>
                    ))}
                  </InfiniteScroll>
                </div>
              }
            </>
          ) : (
            <>
              <div className="md:h-[350px] md:overflow-auto md:pb-4">
                <div>
                  {linkListValue?.data.totalCount === 0 && userInfo && (
                    <>
                      <p className="text-error">
                        아직 확장 프로그램에서 수집한 상품이 없어요!
                      </p>

                      <button className="mt-6 font-bold text-main">
                        <a
                          href="https://www.coupang.com"
                          target="_blank"
                          rel="noreferrer"
                        >
                          상품 수집하기 {`>`}
                        </a>
                      </button>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )
    }
  }

  // useEffect(() => {
  //   if (isOpenExtensionMethod) {
  //     document.body.classList.add('overflow-hidden') // Tailwind 유틸리티 클래스 사용
  //   } else {
  //     document.body.classList.remove('overflow-hidden')
  //   }
  // }, [isOpenExtensionMethod])

  return (
    <>
      <Modal isModal={isOpenExtensionMethod}>
        <div className="fixed left-0 top-0 z-50 flex h-full w-full flex-col items-center justify-center bg-black bg-opacity-50 text-center md:h-screen">
          <div
            className={classNames('', {
              'flex h-auto flex-col gap-8 rounded-t-[20px] bg-white px-8 pt-8 shadow-main md:w-[816px]':
                !isMobile,
              'flex h-full w-full flex-col gap-8 overflow-auto bg-white px-4 pt-10 shadow-main':
                isMobile,
            })}
          >
            <div
              className={classNames('flex w-full flex-col gap-4', {
                'justify-between': isMobile,
              })}
            >
              <p
                className={classNames('flex items-center', {
                  'w-full justify-between': isMobile,
                  'justify-between': !isMobile,
                })}
              >
                <span className="text-left text-[20px] font-bold md:text-[24px]">
                  확장 프로그램에서 수집한 상품{' '}
                  <span className="ml-1 text-main">
                    {linkListValue?.data.totalCount}
                  </span>
                </span>
                <button onClick={handleModalOpen}>
                  <img
                    src="assets/img/Icon_x.png"
                    alt="icon_x"
                    height={24}
                    width={24}
                  />
                </button>
              </p>
              <p
                className={classNames('cursor-pointer', {
                  'flex w-[302px] items-center gap-1 rounded-[20px] bg-black p-2 text-white':
                    !isAiName,
                  'flex w-[302px] items-center gap-1 rounded-[20px] bg-[#4360EC] p-2 text-white':
                    isAiName,
                })}
                onClick={() => {
                  setAiName((prev) => !prev)
                }}
              >
                <input
                  type="checkbox"
                  className={classNames('', {
                    "relative mr-1 h-[18px] w-[18px] cursor-pointer appearance-none rounded-md border border-gray-400 bg-white before:absolute before:left-[5px] before:top-[2px] before:h-[10px] before:w-[5px] before:rotate-45 before:border-b-2 before:border-r-2 before:border-[#D9DEE8] before:opacity-100 before:content-['']":
                      !isAiName,
                    "relative mr-1 h-[18px] w-[18px] cursor-pointer appearance-none rounded-md border border-gray-400 after:absolute after:left-[5px] after:top-[2px] after:h-[10px] after:w-[5px] after:rotate-45 after:border-b-2 after:border-r-2 after:border-[#4360EC] after:opacity-0 after:content-[''] checked:border-[#4360EC] checked:bg-white checked:after:opacity-100":
                      isAiName,
                  })}
                  checked={isAiName}
                />
                <StarIcon />
                <span>AI 생성 상품명으로 개선해서 반영하기</span>
              </p>
            </div>
            <div className=" ">
              {handleDisplayByMobile()}

              {isMobile && (
                <div className="w-[335px] pb-20 pt-5">
                  <button
                    className="h-[60px] w-full rounded-full bg-main font-bold text-white"
                    onClick={() => {
                      handelGetLinkDetailByIds()
                      handleAiRecommendClipTitle()
                    }}
                    type="button"
                    disabled={isPending}
                  >
                    선택 완료{' '}
                    <span className="text-[14px] font-medium">{`(${selectedLinkIds.length}개)`}</span>
                  </button>
                </div>
              )}
            </div>
          </div>
          {!isMobile && (
            <div className="relative z-50 w-full rounded-b-[20px] bg-white p-8 shadow-main before:absolute before:left-0 before:top-[-10px] before:h-[10px] before:w-full before:bg-gradient-to-t before:from-black/10 before:to-transparent before:content-[''] md:w-[816px]">
              <button
                className="h-[60px] w-full rounded-full bg-main font-bold text-white"
                onClick={async () => {
                  handelGetLinkDetailByIds()
                  handleAiRecommendClipTitle()
                }}
                type="button"
                disabled={isPending}
              >
                선택 완료{' '}
                <span className="text-[14px] font-medium">{`(${selectedLinkIds.length}개)`}</span>
              </button>
            </div>
          )}
        </div>
      </Modal>
      <Modal isModal={isOpenErrorModal}>
        <div className="h-auto w-[335px] rounded-t-[20px] border-t bg-white p-[20px]">
          <div className="flex h-full flex-col items-center justify-center gap-[24px]">
            <p className="text-[18px] font-bold">
              🚨 선택 가능 개수를 확인해주세요!
            </p>
            <div className="flex flex-col leading-[22px]">
              <p className="text-[14px] text-[#5E6068]">
                영상을 생성하기 위해서는 <br />
                <span className="font-bold text-main">
                  최소 1개 ~ 최대 3개의 상품을
                </span>
                <br />
                선택해주세요!
              </p>
            </div>
          </div>
        </div>
        <div className="flex h-[60px] w-[335px] items-center justify-center text-[14px]">
          <button
            className="h-full w-[100%] rounded-b-[20px] border-b border-main bg-main font-bold text-white"
            onClick={handleErrorModal}
            type="button"
          >
            확인
          </button>
        </div>
      </Modal>
      <Modal isModal={isOpenDeleteModal}>
        {deletePending ? (
          <>
            <div className="flex h-[222px] w-[335px] flex-col items-center justify-center gap-6 rounded-[20px] border-t bg-white p-[20px]">
              <p className="text-[18px] font-bold">항목 삭제중 ...</p>
              <BeatLoader color="#00B7B9"></BeatLoader>
            </div>
          </>
        ) : (
          <>
            <div className="h-auto w-[335px] rounded-t-[20px] border-t bg-white p-[20px]">
              <div className="flex h-full flex-col items-center justify-center gap-[24px]">
                <p className="text-[18px] font-bold">항목 삭제</p>
                <div className="flex flex-col leading-[22px]">
                  <p className="text-[14px] text-[#5E6068]">
                    <span className="font-bold text-main">
                      선택된 항목을 삭제하시겠어요?
                    </span>
                    <br />
                    삭제된 항목은 되돌릴 수 없습니다.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex h-[60px] w-[335px] items-center justify-center text-[14px]">
              <button
                className="h-full w-[50%] rounded-bl-[20px] border-b border-[EEF1F7] bg-[#EEF1F7] font-bold text-[#5E6068]"
                onClick={handleDeleteModal}
                type="button"
              >
                취소
              </button>
              <button
                className="h-full w-[50%] rounded-br-[20px] border-b border-main bg-main font-bold text-white"
                onClick={handleDeleteLink}
                type="button"
              >
                확인
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  )
}
